(($, Drupal) => {
  Drupal.behaviors.kafRecipeAdInsert = {
    attach: (context) => {

      var $body = $('body', context);
      var $container = $('#recipe-ad__wrapper', context);
      if (!$container || !$body.hasClass('page-node-type-recipe') || !drupalSettings.recipeAdList) {
        return;
      }
      // Insert one of our "ads" below ingredient list and nutritionals.
      var index = Math.floor(Math.random() * drupalSettings.recipeAdList.length);
      let ad = drupalSettings.recipeAdList[index];
      $container.html(`<p><a href="${ad.href}"><img src="${ad.src}" alt="${ad.alt}"></a></p>`);
    }
  };
})(jQuery, Drupal);
